import { useEffect } from "react";

const DEFAULT_FAVICON = "/dibs_assets/favicon.png";
const DEFAULT_TITLE = "Dibs - Dynamic pricing booking system based on demand";
const ALLOWED_TIERS = new Set(["growing", "premium", "enterprise"]);

/**
 * Dynamically updates the browser favicon and document title based on business
 * branding. Only applies custom branding for Growing plan and above. Free
 * plan businesses always see the default Dibs branding.
 *
 * If the business has no avatar_url set, falls back to default Dibs branding
 * regardless of subscription tier.
 *
 * Restores defaults on unmount.
 */
export function useDynamicFavicon(
  avatarUrl: string | null | undefined,
  businessName: string | null | undefined,
  subscriptionTier: string | null | undefined
) {
  useEffect(() => {
    const isEligible = subscriptionTier && ALLOWED_TIERS.has(subscriptionTier.toLowerCase());

    // Favicon
    const faviconLink = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (faviconLink && isEligible && avatarUrl) {
      faviconLink.href = avatarUrl;
    }

    // Document title
    if (isEligible && businessName) {
      document.title = businessName;
    }

    // Cleanup: restore defaults when the component unmounts
    return () => {
      if (faviconLink) {
        faviconLink.href = DEFAULT_FAVICON;
      }
      document.title = DEFAULT_TITLE;
    };
  }, [avatarUrl, businessName, subscriptionTier]);
}
